module.exports = __webpack_public_path__ + "img/bg-quality.28be9deb.png";